/* eslint-disable perfectionist/sort-objects */

const dataManagementPageMapping: { [key: string]: PageMapping } = {
	"/restock/data-management/defaults": {
		nav: true,
		title: "Defaults",
		titleKey: "nav.restock.dataManagement.defaults.title",
		label: "Defaults",
		labelKey: "nav.restock.dataManagement.defaults.label",
		buttons: [],
		actions: []
	},
	"/restock/data-management/items": {
		nav: true,
		title: "Items",
		titleKey: "nav.restock.dataManagement.items.title",
		label: "Items",
		labelKey: "nav.restock.dataManagement.items.label",
		buttons: [],
		actions: []
	},
	"/restock/data-management/locations": {
		nav: true,
		title: "Locations",
		titleKey: "nav.restock.dataManagement.locations.title",
		label: "Locations",
		labelKey: "nav.restock.dataManagement.locations.label",
		buttons: [],
		actions: []
	},
	"/restock/data-management/store-classes": {
		nav: true,
		title: "Store Classes",
		titleKey: "nav.restock.dataManagement.storeClasses.title",
		label: "Store Classes",
		labelKey: "nav.restock.dataManagement.storeClasses.label",
		buttons: [],
		actions: []
	},
	"/restock/data-management/delivery-schedules": {
		nav: true,
		title: "Delivery Schedules",
		titleKey: "nav.restock.dataManagement.deliverySchedules.title",
		label: "Delivery Schedules",
		labelKey: "nav.restock.dataManagement.deliverySchedules.label",
		buttons: [],
		actions: []
	},
	"/restock/data-management/containers": {
		nav: true,
		title: "Containers",
		titleKey: "nav.restock.dataManagement.containers.title",
		label: "Containers",
		labelKey: "nav.restock.dataManagement.containers.label",
		buttons: [],
		actions: []
	},
	"/restock/data-management/rules": {
		nav: true,
		title: "Rules",
		titleKey: "nav.restock.dataManagement.rules.title",
		label: "Rules",
		labelKey: "nav.restock.dataManagement.rules.label",
		buttons: [],
		actions: []
	}
};

export const featurePageMapping: { [key: string]: PageMapping } = {
	"/restock": {
		nav: false,
		title: "",
		label: "RESTOCK",
		labelKey: "nav.restock.module.label",
		icon: "home",
		buttons: [],
		actions: []
	},
	"/restock/dashboard": {
		nav: true,
		title: "Demand Dashboard",
		titleKey: "nav.restock.dashboard.title",
		description: "Network-wide demand vs availability — pre-session view",
		descriptionKey: "nav.restock.dashboard.description",
		label: "Dashboard",
		labelKey: "nav.restock.dashboard.label",
		icon: "insights",
		buttons: [],
		actions: []
	},
	"/restock/load_list": {
		nav: true,
		title: "",
		description: "",
		label: "Load List",
		labelKey: "nav.restock.loadList.label",
		icon: "format_list_bulleted",
		linkOut: "#loadListModal",
		buttons: [],
		actions: []
	},
	"/restock/orders": {
		nav: true,
		title: "",
		description: "",
		label: "Orders",
		labelKey: "nav.restock.orders.label",
		icon: "shopping_cart",
		buttons: [],
		actions: []
	},
	"/restock/orders/kitting": {
		nav: false,
		title: "Kit Builder",
		titleKey: "nav.restock.kitting.title",
		label: "Kit Builder",
		labelKey: "nav.restock.kitting.label",
		icon: "widgets",
		buttons: [],
		actions: []
	},
	"/restock/data-management": {
		nav: false,
		title: "Data Management",
		titleKey: "nav.restock.dataManagement.title",
		label: "Data Management",
		labelKey: "nav.restock.dataManagement.label",
		icon: "database",
		buttons: [],
		actions: [],
		children: dataManagementPageMapping
	}
};

const dashboardPageMapping: { [key: string]: PageMapping } = {
	"/restock/dashboard/session-stub": {
		nav: false,
		title: "New Replenishment Session",
		titleKey: "nav.restock.session.title",
		label: "Session",
		labelKey: "nav.restock.session.label",
		buttons: [],
		actions: []
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping,
	...dataManagementPageMapping,
	...dashboardPageMapping
};
